var map = {
	"./about-card.de-CH.json": 1467,
	"./about-card.de-DE.json": 1468,
	"./about-card.en-CA.json": 1469,
	"./about-card.en-GB.json": 1470,
	"./about-card.en-IN.json": 1471,
	"./about-card.en-ME.json": 1472,
	"./about-card.en-US.json": 1473,
	"./about-card.es-EM.json": 1474,
	"./about-card.es-ES.json": 1475,
	"./about-card.fr-BE.json": 1476,
	"./about-card.fr-CA.json": 1477,
	"./about-card.fr-CH.json": 1478,
	"./about-card.nl-BE.json": 1479,
	"./about-card.nl-NL.json": 1480,
	"./about-card.pl-PL.json": 1481,
	"./about-card.pt-BR.json": 1482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1466;